import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import OriginalsExpandedShopCard from '@wix/da-shared-react/pkg/ShopCard/OriginalsExpandedShopCard';
import { useStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { ShopItemType } from '../../../../../types/shop';
import OriginalsEmptyState from '../_partials/OriginalsEmptyState';
import CreateOriginalCard from '../_partials/CreateOriginalCard';
import StreamPagination from '../../_partials/StreamPagination';
import { getShopItemsStreamId } from '../../../../streams/shop';
import { AppState } from '../../../../../types/store';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';

import s from './ShopOriginals.scss';

export interface Props {
  className?: string;
}

export const ShopOriginals: FC<Props> = ({ className }) => {
  const isProfileOwner = useSelector(isCurrentUserProfileOwner);
  const streamId: string = getShopItemsStreamId(ShopItemType.ORIGINALS);
  const { items: deviationIds } = useStream(streamId);
  const deviations: PapiDeviation[] = useSelector((state: AppState) =>
    getDeviationsByIds(state, deviationIds)
  );

  const hasResults = deviations.length > 0;

  return (
    <BiLoggerContextProvider value={{ sectionname: 'originals' }}>
      <div className={s['root']}>
        {!hasResults && <OriginalsEmptyState view={'wide'} />}
        {hasResults && (
          <>
            {isProfileOwner && <CreateOriginalCard />}
            {deviations.map(deviation => (
              <OriginalsExpandedShopCard
                key={deviation.deviationId}
                deviation={deviation}
              />
            ))}
            <StreamPagination streamId={streamId} />
          </>
        )}
      </div>
    </BiLoggerContextProvider>
  );
};

ShopOriginals.displayName = 'ShopOriginals';
export default ShopOriginals;
